import apiClient from '../../shared/services/apiClient'

const nodeService = {
  // 节点管理
  getNodes: (params = {}) => apiClient.get('/api/admin/node/nodes', { params }).then(res => res.data),
  getNode: (id) => apiClient.get(`/api/admin/node/nodes/${id}`).then(res => res.data),
  createNode: (payload) => apiClient.post('/api/admin/node/nodes', payload).then(res => res.data),
  updateNode: (id, payload) => apiClient.put(`/api/admin/node/nodes/${id}`, payload).then(res => res.data),
  deleteNode: (id) => apiClient.delete(`/api/admin/node/nodes/${id}`).then(res => res.data),
  regenerateNodeKey: (id) => apiClient.post(`/api/admin/node/nodes/${id}/regenerate-key`).then(res => res.data),
  getNodeMetrics: (id, params = {}) => apiClient.get(`/api/admin/node/nodes/${id}/metrics`, { params }).then(res => res.data),
  getNodeCredentials: (id) => apiClient.get(`/api/admin/node/nodes/${id}/credentials`).then(res => res.data),
  testNodeConnection: (id) => apiClient.post(`/api/admin/node/nodes/${id}/test-connection`).then(res => res.data),
  deployNode: (id, payload = {}) => apiClient.post(`/api/admin/node/nodes/${id}/deploy`, payload).then(res => res.data),
  getDeployScript: (id) => apiClient.get(`/api/admin/node/nodes/${id}/deploy-script`).then(res => res.data),
  batchAction: (payload) => apiClient.post('/api/admin/node/nodes/batch', payload).then(res => res.data),

  // 任务管理
  getTaskStatus: (taskId) => apiClient.get(`/api/admin/node/tasks/${taskId}`).then(res => res.data),
  getNodeTasks: (nodeId) => apiClient.get(`/api/admin/node/nodes/${nodeId}/tasks`).then(res => res.data),

  // 概览
  getOverview: () => apiClient.get('/api/admin/node/overview').then(res => res.data),

  // 分组管理
  getGroups: (params = {}) => apiClient.get('/api/admin/node/groups', { params }).then(res => res.data),
  getGroup: (id) => apiClient.get(`/api/admin/node/groups/${id}`).then(res => res.data),
  createGroup: (payload) => apiClient.post('/api/admin/node/groups', payload).then(res => res.data),
  updateGroup: (id, payload) => apiClient.put(`/api/admin/node/groups/${id}`, payload).then(res => res.data),
  deleteGroup: (id) => apiClient.delete(`/api/admin/node/groups/${id}`).then(res => res.data),
  updateGroupSort: (payload) => apiClient.post('/api/admin/node/groups/sort', payload).then(res => res.data),
  getGroupNodes: (id) => apiClient.get(`/api/admin/node/groups/${id}/nodes`).then(res => res.data),

  // 业务节点绑定
  getBusinessNodes: (type) => apiClient.get('/api/admin/node/business-nodes', { params: { type } }).then(res => res.data),
  bindBusinessNode: (id, businessNodeId) => apiClient.post(`/api/admin/node/nodes/${id}/bind`, { business_node_id: businessNodeId }).then(res => res.data),
  unbindBusinessNode: (id) => apiClient.post(`/api/admin/node/nodes/${id}/unbind`).then(res => res.data),

  // 同步管理 - 导入业务节点
  getSyncStats: () => apiClient.get('/api/admin/node/sync/stats').then(res => res.data),
  getAvailableNodes: (params = {}) => apiClient.get('/api/admin/node/sync/available', { params }).then(res => res.data),
  getSyncedNodes: (params = {}) => apiClient.get('/api/admin/node/sync/synced', { params }).then(res => res.data),
  syncOne: (payload) => apiClient.post('/api/admin/node/sync/one', payload).then(res => res.data),
  syncBatch: (payload) => apiClient.post('/api/admin/node/sync/batch', payload).then(res => res.data),
  syncAll: (payload = {}) => apiClient.post('/api/admin/node/sync/all', payload).then(res => res.data),
  unsync: (id) => apiClient.delete(`/api/admin/node/sync/${id}`).then(res => res.data),
}

export default nodeService
